// Copy for the checkout screens, used as t("ui.checkout.*").
// Numbers are formatted in code (formatNumber / formatMoney / formatPercent) and passed in as strings.
export default {
  title: "خرید اشتراک",
  account: "اشتراک برای",
  heading: "مدت اشتراکت رو انتخاب کن",
  subheading: "همه پلن‌ها همه امکانات پرو رو دارن، فرقشون فقط مدت اشتراکه.",
  plans: {
    label: "پلن‌های اشتراک",
    best: "به‌صرفه‌ترین",
    saving: "{{percent}} کمتر از ماهانه",
    savingShort: "{{percent}} کمتر",
    month: "ماه",
    empty: {
      title: "الان پلنی برای خرید نیست",
      body: "اگه فکر می‌کنی اشتباهی پیش اومده، تو دایرکت اینستاگرام فونتا بهمون پیام بده.",
      action: "پیام در اینستاگرام",
    },
  },
  features: { title: "با پرو این‌ها برات باز می‌شه" },
  pay: {
    title: "تکمیل خرید",
    selected: "پلن انتخابی",
    change: "تغییر",
    changeLabel: "تغییر پلن",
    method: "روش پرداخت",
    howTo: "نحوه واریز",
    howToBody: "مبلغ رو به کارت زیر واریز کن، بعد عکس رسید رو همین‌جا آپلود کن و درخواستت رو ثبت کن.",
    rial: "یعنی {{amount}} ریال، اگه اپ بانکت مبلغ رو ریالی می‌خواد.",
    transferred: "واریز کردم، بریم سراغ رسید",
    resume: "برگشتی! اگه واریز رو انجام دادی، فقط عکس رسیدش مونده.",
    note: "بعد از بررسی رسید، اشتراکت فعال می‌شه.",
    policy: "با ثبت خرید، <0>قوانین استفاده</0> و <1>حریم خصوصی</1> فونتا رو قبول می‌کنی.",
    steps: { label: "مراحل خرید", plan: "پلن", transfer: "واریز", receipt: "رسید", done: "انجام شد", current: "مرحله فعلی" },
  },
  gateways: {
    offline: { title: "کارت به کارت", subtitle: "واریز به کارت فونتا و ارسال عکس رسید" },
    selected: "انتخاب شده",
  },
  bank: {
    card: "شماره کارت",
    iban: "شماره شبا",
    owner: "به نام",
    amount: "مبلغ واریز",
    copy: "کپی",
    copied: "کپی شد",
    copyFailed: "کپی نشد",
    copyCard: "کپی شماره کارت",
    copyIban: "کپی شماره شبا",
    copyAmount: "کپی مبلغ",
  },
  receipt: {
    label: "عکس رسید واریز",
    pick: "بزن تا عکس رسید رو انتخاب کنی",
    drop: "یا فایلش رو بکش و اینجا رها کن",
    dropActive: "رها کن تا آپلود بشه",
    uploading: "در حال آپلود رسید",
    processing: "داره ثبت می‌شه، یه لحظه صبر کن",
    done: "رسید آپلود شد",
    replace: "عوض کردن",
    remove: "حذف رسید",
    progress: "آپلود رسید",
    previewAlt: "پیش‌نمایش رسید",
    kb: "{{size}} کیلوبایت",
    mb: "{{size}} مگابایت",
  },
  submit: {
    submitting: "یه لحظه صبر کن",
    iap: "منتظر باز شدن پنجره پرداخت باش",
    selectPlan: "اول یه پلن انتخاب کن",
    selectGateway: "اول روش پرداخت رو انتخاب کن",
    uploadReceipt: "اول عکس رسید رو آپلود کن",
    uploading: "صبر کن تا رسید آپلود بشه",
    register: "ثبت درخواست واریز",
  },
  sent: "رسیدت ثبت شد. بعد از بررسی، اشتراکت فعال می‌شه.",
  paid: {
    title: "اشتراکت فعال شد",
    body: "جزئیات اشتراکت رو هر وقت خواستی توی حساب کاربری می‌بینی.",
    cta: "رفتن به حساب کاربری",
    tutorialTitle: "اشتراک رو به اپ وصل کن",
    tutorialBody: "آموزشش تو این پست اینستاگرام فونتاست. اگه مشکلی داشتی، تو دایرکت بهمون پیام بده.",
    tutorialCta: "دیدن آموزش",
  },
  status: {
    reloadIn: "صفحه تا {{seconds}} ثانیه دیگه دوباره باز می‌شه",
  },
  loading: "در حال بارگذاری",
};
